import { Component, Input } from '@angular/core';

@Component({
    selector: 'ins-animated-hand',
    templateUrl: 'animated-hand.component.html',
    styleUrls: ['animated-hand.component.scss']
})
export class AnimatedHandComponent {
    @Input() type: string = null;
    @Input() size: string = null;
    @Input() device: string = null;
    @Input() flipped: boolean = false;
    @Input() averageScore?: string = null;

    constructor() {}
}
